import React, { Component } from "react";
import axios from "axios";
import { user as userModule, config, utils } from "@myplay/all";
import { withAlert } from "react-alert";


const MYPLAY_ID_ROUTE = "https://id.myplay.com";
// const MYPLAY_ID_ROUTE = "http://localhost:3002";
const auth = userModule.auth;

class UserProvider extends Component {
  state = {
    isLoggedIn: false,
    userData: null
  };

  async componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get("accessToken");
    const refreshToken = params.get("refreshToken");
    const userId = params.get("userId");
    
    if (accessToken && refreshToken && userId) {
      window.history.replaceState( {} , null, "/");
      await this.handleUrlParams({
        userId,
        accessToken, 
        refreshToken
      });
    }
    this.isLoggedIn();

    config.addHeader("platform", "admin-panel");
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      async error => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401) {
          if (
            error.response.status === 401 &&
            error.config.url.indexOf("auth/user") === -1 &&
            error.config.url.indexOf("getAccessToken") === -1
          ) {
            const res = await auth.refreshAccessToken(
              this.getAccessToken(),
              this.getRefreshToken()
            );
            this.setAccessToken(res.accessToken);
            originalRequest.headers["Authorization"] =
              "Bearer " + res.accessToken;
            return utils.sendRequest(originalRequest);
          }
          this.clearPrivateData();
          return Promise.reject(error);
        } else if (error.response && error.response.status === 403) {
          this.clearPrivateData();
          return Promise.reject(error);
        }
        return Promise.reject(error);
      }
    );
  };

  // addAuthInterceptor = () => {
  //   config.addInterceptor(
  //     function(response) {
  //       return response;
  //     },
  //     async error => {
  //       const originalRequest = error.config;
  //       if (error.response.status === 401) {
  //         console.log("intercepted here?!?");
  //         if (
  //           error.response.status === 401 &&
  //           error.config.url.indexOf("auth/user") === -1 &&
  //           error.config.url.indexOf("getAccessToken") === -1
  //         ) {
  //           const res = await auth.refreshAccessToken(
  //             this.getAccessToken(),
  //             this.getRefreshToken()
  //           );
  //           this.setAccessToken(res.accessToken);
  //           originalRequest.headers["Authorization"] =
  //             "Bearer " + res.accessToken;
  //           return utils.sendRequest(originalRequest);
  //         }

  //         this.clearPrivateData();
  //         return Promise.reject(error);
  //       } else if (error.response.status === 403) {
  //         return Promise.reject(error);
  //       }
  //       return Promise.reject(error);
  //     }
  //   );
  // };

  // login = async (email, password) => {
  //   const { alert } = this.props;
  //   try {
  //     const res = await auth.login(email, password);
  //     this.setAccessToken(res.accessToken); // eslint-disable-line
  //     this.setRefreshToken(res.refreshToken);
  //     this.setUserData(res.userData);
  //     this.setState({
  //       isLoggedIn: this.isLoggedIn(),
  //       userData: this.getUserData()
  //     });
  //   } catch (e) {
  //     if (e.name === "VisibleError") {
  //       alert.show(e.message);
  //     }
  //   }
  // };

  logout = () => {
    this.clearPrivateData();
    window.location.href = `${MYPLAY_ID_ROUTE}/logout`;
  };

  isLoggedIn = () => {
    if (this.getAccessToken() != null && this.getUserData() != null) {
      axios.defaults.headers.common.Authorization = `Bearer ${this.getAccessToken()}`;
      this.setState({ isLoggedIn: true });
      return true;
    }
    const redirect = `${window.location.protocol}//${window.location.host}`
    window.location.href = `${MYPLAY_ID_ROUTE}/?redirect=${redirect}`;
    return false;
  };

  setAccessToken = accessToken => {
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    userModule.auth.setAccessToken(accessToken);
    window.localStorage.setItem("MYPLAY/accessToken", accessToken);
  };

  getAccessToken = () => {
    return window.localStorage.getItem("MYPLAY/accessToken");
  };

  setRefreshToken = refreshToken => {
    userModule.auth.setRefreshToken(refreshToken);
    window.localStorage.setItem(
      "MYPLAY/refreshToken",
      refreshToken
    );
  };

  getRefreshToken = () => {
    return window.localStorage.getItem("MYPLAY/refreshToken");
  };

  setUserData = userData => {
    window.localStorage.setItem(
      "MYPLAY/userData",
      JSON.stringify(userData)
    );
  };

  getUserData = () => {
    return window.localStorage.getItem("MYPLAY/userData");
  };

  clearPrivateData = () => {
    window.localStorage.removeItem("MYPLAY/accessToken");
    window.localStorage.removeItem("MYPLAY/userData");
    window.localStorage.removeItem("MYPLAY/refreshToken");
    // this.setState({ isLoggedIn: this.isLoggedIn() });
  };

  handleUrlParams = async ({ userId, accessToken, refreshToken }) => {
    const user = this.getUserData();
    if (!user || user.id !== userId) {
      this.setRefreshToken(refreshToken);
      this.setAccessToken(accessToken);
      const userData = await userModule.auth.getUserData(userId);
      this.setUserData(userData);
    };
  }

  render() {
    return this.props.render(this.state, this.login, this.logout);
  }
}

export default withAlert()(UserProvider);
